(function () {
  const initCartRecommendationsSlider = () => {
    const sliderElement = document.querySelector('[data-cart-recommendations-slider]');

    if (!sliderElement) return;

    // Los botones están fuera del slider, así que los buscamos en el contenedor padre
    const container = sliderElement.closest('.cart-recommendations');
    const nextEl = container.querySelector('.cart-recommendations__nav--next');
    const prevEl = container.querySelector('.cart-recommendations__nav--prev');

    const cartRecommendationsSwiper = new Swiper('[data-cart-recommendations-slider]', {
      slidesPerView: 1.6,
      spaceBetween: 3,
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        751: {
          slidesPerView: 3,
          spaceBetween: 90,
          centeredSlides: false,
        }
      }
    });
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartRecommendationsSlider);
  } else {
    initCartRecommendationsSlider();
  }

  // Re-initialize when cart drawer is updated
  document.addEventListener('cart:refresh', initCartRecommendationsSlider);

  // Re-initialize after cart updates
  if (typeof Shopify !== 'undefined' && Shopify.theme) {
    document.addEventListener('shopify:section:load', initCartRecommendationsSlider);
  }
})();
